import React from "react";
import Seo from "components/Seo";
import CompanyLayout from "./companyLayout";
import History from "../../../common/-pages/company/history";

const MorningHistory = () => {
    return (
        <React.Fragment>
            <Seo type="morning" pageTitle="연혁" />
            <CompanyLayout>
                <History type="morning" />
            </CompanyLayout>
        </React.Fragment>
    );
};

export default MorningHistory;
